import { Component, OnInit, Input } from '@angular/core';
import { Offerte } from '../model/offerte';

@Component({
  selector: 'app-offerta-min-descrizione',
  templateUrl: './offerta-min-descrizione.component.html',
  styleUrls: ['./offerta-min-descrizione.component.scss']
})
export class OffertaMinDescrizioneComponent implements OnInit {
  
  constructor() { }
  @Input () offerta:Offerte ;
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/offerta-min-descrizione/offerta-min-descrizione.component.ts